import './company-verification-modal.scss';
import Modal from 'modules/modal';

interface ICompanyVerificationModal {
  open: boolean;
  onClose: () => void;
  companyName: string;
  onSubmit: () => void;
}

export default function CompanyVerificationModal({
  open,
  onClose,
  companyName,
  onSubmit,
}: ICompanyVerificationModal) {
  return (
    <div className="company-verification-modal">
      <Modal
        header={<b>Подтверждение данных компании</b>}
        open={open}
        onClose={onClose}
        body={
          <p className="p">
            Вы уверены, что хотите подтвердить данные
            <br />
            Пользователя <b>{companyName}</b>
            <br />и предоставить ему доступ на платформу?
          </p>
        }
        footer={{
          left: (
            <button className="button button_secondary" onClick={onClose}>
              Отмена
            </button>
          ),
          right: (
            <button className="button button_primary" onClick={onSubmit}>
              Валидировать
            </button>
          ),
        }}
      />
    </div>
  );
}
